import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { DownTimeReason } from './dto/downtimereason.entity';
import { DownTimeReasonAdapter } from './dto/downtimereason.adapter';
import { DownTimeReasonDto } from './dto/downtimereason.dto';
import { DownTimeReasonResponsemodel , AllDownTimeReasonResponseModel } from '@gtpl/shared-models/masters';
import { DownTimeReasonService } from './downtimereason.service';
import { DownTimeReasonRequest } from './dto/downtimereason.request';


@ApiTags('downtimereason')
@Controller('downtimereason')
export class DownTimeReasonController {

    constructor(
      private downtimereasonService: DownTimeReasonService,
      private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}

   @Post('/createDownTimeReason')
    async createDownTimeReason(@Body() downtimereasonDto:DownTimeReasonDto,isUpdate:boolean=false): Promise<DownTimeReasonResponsemodel> {
    try {
        return await this.downtimereasonService.createDownTimeReason(downtimereasonDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(DownTimeReasonResponsemodel, error);
      }
    }

    @Post('/updateDownTimeReason')
    async updateDownTimeReason(@Body() downtimeresonDto: DownTimeReasonDto,@Req() request:Request): Promise<DownTimeReasonResponsemodel> {
      try {
        console.log('update downtimereason');downtimeresonDto
        console.log(request);
        return await this.downtimereasonService.createDownTimeReason(downtimeresonDto, true);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(DownTimeReasonResponsemodel, error);
      }
    }

    @Post('/getAllDownTimeReason')
    // @UseGuards(AuthGuard('jwt'))
    async getAllDownTimeReasons(): Promise<AllDownTimeReasonResponseModel> {
      try {
        return await this.downtimereasonService.getAllDownTimeReasons();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(AllDownTimeReasonResponseModel, error);
      }
    }
    
    @Post('/activateOrDeactivateDownTimeReason')
    async activateOrDeactivateDownTimeReason(@Body() downtimereasonreq: DownTimeReasonRequest): Promise<DownTimeReasonResponsemodel> {
        try {
            return await this.downtimereasonService.activateOrDeactivateDownTimeReason(downtimereasonreq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(DownTimeReasonResponsemodel, err);
        }
    }

    @Post('/getAllActiveDownTimeReason')
    async getAllActiveDownTimeReason(@Req() request: Request): Promise<AllDownTimeReasonResponseModel> {
        try {
            return await this.downtimereasonService.getAllActiveDownTimeReason();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllDownTimeReasonResponseModel, error)
        }
    }

    @Post('/getDowTimeReasonById')
  async getDowTimeReasonById(@Body() downtimereasonreq: DownTimeReasonRequest): Promise<DownTimeReasonResponsemodel> {
      try {
          return await this.downtimereasonService.getActiveDownTimeReasonById(downtimereasonreq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(DownTimeReasonResponsemodel, err);
      }
  }
}